import { Object, String, Static } from '@sinclair/typebox';

export type IdRequestParams = Static<typeof IdRequestParams>;
export const IdRequestParams = Object({
  id: String(),
});
